import { Container } from "components";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import api from "services/api";

export default function DashBEnrollPI() {
  const [memberships, setMemberships] = useState([]);
  const params = useParams();
  console.log("params: ", params?.id);
  const navigate = useNavigate();

  const fetchMembershipData = async () => {
    try {
      const response = await api.get(
        `/membership-application?enrollId=${params?.id}`
      );
      setMemberships(response?.data.data.memberApplication);
      console.log("membershipList:", response.data.data?.memberApplication);
    } catch (error) {
      console.log("membershipList error:", error);
    }
  };
  useEffect(() => {
    fetchMembershipData();
  }, []);

  return (
    <Container>
      <div class="content-wrapper ">
        <div
          class="container-xxl flex-grow-1 container-p-y"
          style={{ height: "43px" }}
        >
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <Link to="/dashboard">Dashboard</Link>
              </li>
              <li class="breadcrumb-item active">Enrol Plans</li>
            </ol>
          </nav>
          {memberships.length > 0 && (
            <div>
              <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item active">
                    <strong>Plan:</strong> {memberships[0]?.membership_plan?.title}
                  </li>
                </ol>
              </nav>
              <div class="card-datatable table-responsive">
                <table class="invoice-list-table table border-top dataTable no-footer dtr-column mb-5">
                  <thead>
                    <tr>
                      <th>FirstName</th>
                      <th>LastName</th>
                      <th class="text-truncate">Relation</th>
                      <th class="text-truncate">Status</th>
                      <th>PLAN</th>
                      <th>APPLICATION NUMBER</th>
                      <th class="text-truncate">Valid Till</th>
                      <th class="cell-fit">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {memberships.map((res, index) => {
                      return (
                        <tr key={index}>
                          <td>{res.first_name}</td>
                          <td>{res.last_name}</td>
                          <td>{res.relation}</td>
                          <td>
                            <span
                              className={`badge ${
                                res.status === "Pending"
                                  ? "bg-warning"
                                  : res.status === "Approved"
                                  ? "bg-success"
                                  : "bg-danger"
                              }`}
                            >
                              {res.status}
                            </span>
                          </td>
                          <td
                            dangerouslySetInnerHTML={{
                              __html: res.membership_plan.title,
                            }}
                          />
                          <td>{res.application_no}</td>
                          <td>{res.end_date}</td>
                          <td>
                            <button
                              variant="outlined"
                              className="btn btn-primary me-2"
                              onClick={() =>
                                navigate(
                                  `/membershipDetails/${res.application_no}`
                                )
                              }
                            >
                              View
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      </div>
    </Container>
  );
}
